/* eslint-disable prettier/prettier */
/* eslint-disable */

import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

// @mui material components
import Container from "@mui/material/Container";
import Icon from "@mui/material/Icon";
import MuiLink from "@mui/material/Link";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

// Material Kit 2 React examples
import DefaultNavbarMobile from "examples/Navbars/DefaultNavbar/DefaultNavbarMobile";

// Theme
import breakpoints from "assets/theme/base/breakpoints";

function DefaultNavbar({ brand, transparent, action }) {
  const [mobileNavbar, setMobileNavbar] = useState(false);
  const [mobileView, setMobileView] = useState(window.innerWidth < breakpoints.values.lg);

  const toggleMobileNavbar = () => setMobileNavbar((prev) => !prev);

  useEffect(() => {
    const handleResize = () => setMobileView(window.innerWidth < breakpoints.values.lg);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <MKBox
      py={1}
      px={3}
      width="100%"
      borderRadius="0px" // Use string for borderRadius
      boxShadow="md"
      position="fixed" // Sticky navbar
      top={0}
      left={0}
      zIndex={1000} // Ensures navbar is always on top
      sx={({ palette: { white, dark }, functions: { rgba } }) => ({
        backgroundColor: transparent ? "transparent" : rgba(dark.main, 0.7), // Semi-transparent background
        backdropFilter: "blur(15px)", // Glassmorphism
        transition: "all 0.3s ease-in-out",
      })}
    >
      <Container>
        <MKBox display="flex" justifyContent="space-between" alignItems="center">
          {/* Logo / Brand */}
          <MKBox component={Link} to="/" lineHeight={1} py={0.75}>
            <MKTypography variant="button" fontWeight="bold" color="white">
              {brand}
            </MKTypography>
          </MKBox>

          {/* Desktop Navbar */}
          <MKBox display={{ xs: "none", lg: "flex" }} ml="auto">
          {["Hjem","Om oss", "Kontakt oss", "Utleie"].map((text, index) => ( // BRANDS må legges til her , "Brands"
            <MKBox
              key={index}
              component={MuiLink}
              href={`/${text.toLowerCase().replace(/\s+/g, "-")}`} // Automatic URL generation
              color="white"
              mx={2}
              sx={{
                position: "relative",
                textTransform: "uppercase",
                fontSize: "0.9rem",
                fontWeight: "500",
                transition: "color 0.3s ease-in-out",
                "&:hover": {
                  color: "info.main",
                },
                "&::after": {
                  content: '""',
                  position: "absolute",
                  left: "50%",
                  bottom: "-4px",
                  width: "0%",
                  height: "2px",
                  backgroundColor: "info.main",
                  transition: "all 0.3s ease-in-out",
                  transform: "translateX(-50%)",
                },
                "&:hover::after": {
                  width: "100%",
                },
              }}
            >
              {text}
            </MKBox>
          ))}
        </MKBox>


          {/* Action Button */}
          {action && (
            <MKButton
              component={action.type === "internal" ? Link : "a"}
              to={action.type === "internal" ? action.route : undefined}
              href={action.type === "external" ? action.route : undefined}
              target={action.type === "external" ? "_blank" : undefined}
              variant={["contained", "gradient"].includes(action.color) ? action.color : "contained"} // Ensure "contained" or "gradient"
              color={action.color || "info"}
              size="small"
              ml={2}
            >
              {action.label}
            </MKButton>
          )}

          {/* Mobile Navbar Toggle */}
          <MKBox
            display={{ xs: "inline-block", lg: "none" }}
            py={1.5}
            pl={1.5}
            sx={{ cursor: "pointer" }}
            onClick={toggleMobileNavbar}
          >
            <Icon fontSize="default" sx={{ color: "gray", fontSize: "2rem" }}>
              {mobileNavbar ? "close" : "menu"}
            </Icon>
          </MKBox>
        </MKBox>

        {/* Mobile Navbar */}
        {mobileView && (
          <DefaultNavbarMobile
            routes={[
              { name: "Hjem", route: "/" },
              { name: "Om oss", route: "/om-oss" },
              { name: "Kontakt oss", route: "/kontakt-oss" },
              { name: "Utleie", route: "/utleie" },
             // { name: "Brands", route: "/brands" },}
            ]}
            open={mobileNavbar}
          />
        )}
      </Container>
    </MKBox>
  );
}

// Default Props
DefaultNavbar.defaultProps = {
  brand: "T-Event",
  transparent: false,
  action: null,
};

// PropTypes
DefaultNavbar.propTypes = {
  brand: PropTypes.string,
  transparent: PropTypes.bool,
  action: PropTypes.shape({
    type: PropTypes.oneOf(["external", "internal"]).isRequired,
    route: PropTypes.string.isRequired,
    color: PropTypes.oneOf([
      "primary", "secondary", "info", "success", "warning", "error", "dark", "light", "default", "white",
    ]),
    label: PropTypes.string.isRequired,
  }),
};

export default DefaultNavbar;
